import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { CgMenuGridO } from "react-icons/cg";
import { IoClose } from "react-icons/io5";
import { FaLanguage } from "react-icons/fa";
import ResponsiveMenu from "./ResponsiveMenu";
import logo from "../assets/finance7.png";
import Translator from "./Essentials/Translator";

const navItems = [
  { path: "/", label: "Home" },
  { path: "/plans", label: "Plans"},
  { path: "/solutions", label: "Our Solution" },
  { path: "/contact", label: "Contact Us" },
   { path: "/approach", label: "Our Approach"},
];

const Navbar = () => {
  const [showMenu, setShowMenu] = useState(false);
  const [showTranslator, setShowTranslator] = useState(false);

  const toggleMenu = () => setShowMenu(!showMenu);
  const toggleTranslator = () => setShowTranslator(!showTranslator);

  const handleHomeClick = () => {
    window.scrollTo(0, 0);
    window.location.href = "/";
  };

  return (
    <>
      <header className="fixed top-0 left-0 w-full z-[1050]">
        {/* Notification Banner */}
        <div className="w-full bg-gray-100 text-[#000] text-center py-2 text-sm font-medium">
          <span className="hidden lg:inline">Not English? Click 'Change Language'</span>
          <span className="lg:hidden text-xs">Not English? Click below</span>
        </div>

        <nav className="bg-[#000300] shadow-md w-full relative z-[1050]">
          <div className="container mx-auto flex items-center justify-between py-3 px-4 sm:px-6 lg:px-8">
            {/* Mobile Menu Button - Left Side */}
            <div className="md:hidden flex items-center w-1/4 min-w-[40px] justify-start">
              {showMenu ? (
                <IoClose
                  onClick={toggleMenu}
                  className="text-[#fff] cursor-pointer transition-transform hover:scale-110"
                  size={26}
                />
              ) : (
                <CgMenuGridO
                  onClick={toggleMenu}
                  className="text-[#fff] cursor-pointer transition-transform hover:scale-110"
                  size={24}
                />
              )}
            </div>

            {/* Logo Section - Centered */}
            <div className="flex items-center justify-center w-1/2 md:w-auto px-0.1 ml-12">
              <Link to="/" onClick={handleHomeClick}>
                <img 
                  src={logo} 
                  alt="Shipping Site Logo" 
                  className="h-7 sm:h-9 lg:h-10 w-auto mx-auto" 
                />
              </Link>
            </div>

            {/* Desktop Navigation and Language Selector - Right Side */}
            <div className="hidden md:flex items-center gap-3 lg:gap-6">
              <ul className="flex items-center text-[#fff] font-medium whitespace-nowrap">
                {navItems.map(({ path, label }) => (
                  <li key={path} className="px-2 sm:px-3 md:text-[13px] lg:text-sm">
                    <NavLink
                      to={path}
                      className={({ isActive }) =>
                        isActive
                          ? "text-gray-400 font-semibold md:text-[13px] lg:text-base"
                          : "hover:text-gray-400 transition-colors duration-300 text-[13px] lg:text-base"
                      }
                      onClick={() => window.scrollTo(0, 0)}
                    >
                      {label}
                    </NavLink>
                  </li>
                ))}
              </ul>

              {/* Desktop Language Selector Button */}
              <button 
                onClick={toggleTranslator}
                className="flex items-center gap-1 lg:gap-2 text-[#fff] hover:text-gray-400 transition-colors duration-300 font-semibold text-sm lg:text-base whitespace-nowrap"
                aria-label="Change language"
              >
                <FaLanguage className="text-base lg:text-lg" />
                <span>Change Language</span>
              </button>
            </div>

            {/* Mobile Language Button - Right Side */}
            <div className="md:hidden flex items-center w-1/4 min-w-[110px] justify-end pt-1">
              <button 
                onClick={toggleTranslator}
                className="flex items-center gap-1 text-white font-medium text-xs sm:text-sm tracking-normal border border-gray-600 px-1 py-1 rounded-md hover:bg-gray-800 transition-all duration-200 whitespace-nowrap"
                aria-label="Change language"
              >
                <FaLanguage className="text-base" />
                <span>Language</span>
              </button>
            </div>
          </div>
        </nav>
      </header>

      {/* Mobile Menu */}
      {showMenu && (
        <div className="md:hidden fixed top-[calc(3.5rem+1rem)] left-0 w-full bg-white shadow-md transition-all duration-300 z-[1000]">
          <ResponsiveMenu setShowMenu={setShowMenu} showMenu={showMenu} />
        </div>
      )}

      {/* Translator Card Popup */}
      <Translator show={showTranslator} onClose={toggleTranslator} />
    </>
  );
};

export default Navbar;